import { Component, inject, Input, OnInit } from '@angular/core';
import { GrowAccountOverview, GrowOverviewInvestment } from '@inyova/grow';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-inyova-grow-net-return-modal',
  templateUrl: './inyova-grow-net-return-modal.component.html',
  styleUrls: ['./inyova-grow-net-return-modal.component.scss'],
  standalone: false
})
export class InyovaGrowNetReturnModalComponent implements OnInit {
  private modalController = inject(ModalController);

  filteredInvestments: GrowOverviewInvestment[];

  @Input() overview: GrowAccountOverview;

  info = {
    currentNetYield: false,
    breakdown: false
  };

  ngOnInit(): void {
    // filter only investment
    this.filteredInvestments = this.overview.investments.filter((investment) => investment.status === 'invested');
  }

  onDismiss() {
    void this.modalController.dismiss();
  }

  onShowInfo(block: 'currentNetYield' | 'breakdown') {
    this.info[block] = !this.info[block];
  }
}
